import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchCompanyProfileTypes, deleteCompanyProfileType } from "actions/companyProfileType";
import { toggleconfirmationPopup, toggleNotification } from "actions/toggle";

import SearchForm from "./SearchForm";
import Table from "./Table";
import Pagination from "components/Pagination";

class CompanyProfileTypeIndex extends Component {
  componentDidMount() {
    this.props.fetchCompanyProfileTypes();

    this.search = {};
  }

  onSearchFormSubmit = data => {
    this.search = { [data.search_by]: data.search_term };
    this.props.fetchCompanyProfileTypes({ ...this.search });
  };

  onPaginationClick = page => event => {
    const { companyProfileTypeURL: companyProfileType_url } = this.props.match.params;
    this.props.fetchCompanyProfileTypes({ companyProfileType_url, page, ...this.search });
  };

  handleCompanyProfileTypeDelete = id => event => {
    const { toggleconfirmationPopup } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        this.deleteCompanyProfileTypeProcess(id);
      },
      title: "Delete companyProfileType",
      body: "Are you sure you want to delete this companyProfileType?"
    });
  };

  deleteCompanyProfileTypeProcess(id) {
    const { toggleNotification, toggleconfirmationPopup, deleteCompanyProfileType, match } = this.props;
    const { companyProfileTypeURL: companyProfileType_url } = match.params;
    deleteCompanyProfileType(id, { companyProfileType_url })
      .then(() => {
        this.props.fetchCompanyProfileTypes({ ...this.search });
        toggleNotification(true, { infoClassName: "is-success", message: "Delete CompanyProfileType Success" });
        toggleconfirmationPopup(false, {});
      })
      .catch(({ message }) => {
        toggleNotification(true, { infoClassName: "is-danger", message });
        toggleconfirmationPopup(false, {});
      });
  }

  render() {
    const { companyProfileTypes } = this.props;

    return (
      <div>
        <div className="box">
          <SearchForm onSearchFormSubmit={this.onSearchFormSubmit} />
          <Table companyProfileTypes={companyProfileTypes} onClickDelete={this.handleCompanyProfileTypeDelete} />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={companyProfileTypes.current_page}
            lastPage={companyProfileTypes.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authCompanyProfileType, companyProfileTypes, confirmationPopupActive }) => ({
  authCompanyProfileType,
  companyProfileTypes,
  confirmationPopupActive
});

export default connect(
  mapStateToProps,
  { fetchCompanyProfileTypes, deleteCompanyProfileType, toggleconfirmationPopup, toggleNotification }
)(CompanyProfileTypeIndex);



// WEBPACK FOOTER //
// ./src/pages/CompanyProfileType/Index/index.js